import { useTheme } from '@mui/styles';
import { useMemo } from 'react';

// Q: Why don't we type the return value with `SxProps`?
// A: Because it's a generic type, and it's not clear to me how to fill the generics,
//    and simply leaving it blank causes type errors when using this function in
//    more deeply nested places in `sx` props. Best to leave the return type
//    implicitly set to the actual shape of the object returned.
export const useAnimatedVisibility = (isVisible: boolean) => {
    return {
        // Copied from https://stackoverflow.com/a/6943704/1292652
        opacity: isVisible ? 1 : 0,
        height: isVisible ? 'auto' : 0,
        // Use default margin when drawer is expanded, remove useless spacing when drawer collapsed.
        padding: isVisible ? undefined : 0,
        // We don't want to animate opacity as it looks weird; we want the drawer to just disappear/appear.
        // But we do want the height and padding to be animated.
        transition: useTransition(['height', 'padding']),
    };
};

export const useTransition = (properties: string[]) => {
    const theme = useTheme();
    return useMemo(() => theme.transitions.create(properties), [theme, properties]);
};
